<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-app-bar app flat height="79px">

        <v-app-bar-nav-icon class="hidden-lg-and-up" @click.stop="mobileMenu = !mobileMenu"></v-app-bar-nav-icon>

        <a class="logo d-none d-sm-flex ma-sm-3" href="orders">
            <v-img v-if="logo" class="logo d-none d-sm-flex ma-sm-3" :src="logo" width="82px"></v-img>
            <v-img v-else class="logo d-none d-sm-flex ma-sm-3" src="../assets/logo-plus.png" width="82px"></v-img>
        </a>

        <v-toolbar-items class="hidden-md-and-down" id="nav">
            <router-link v-if="$isPermitted('viewDashboard') && !dashboardProPermission()" class="d-flex align-center justify-center"
                         :to="{name:'dashboard'}">
                <span class="d-flex align-center justify-center">{{ $t('dashboard') }}</span>
            </router-link>

            <router-link v-if="$isPermitted('viewDashboard') && dashboardProPermission()" class="d-flex align-center justify-center"
                         :to="{name:'dashboardPro'}">
                <span class="d-flex align-center justify-center">{{ $t('dashboard') }} Pro</span>
            </router-link>

            <router-link v-if="$isPermitted('viewCmrs')" class="d-flex align-center justify-center"
                         :to="{name:'orders'}">
                <span class="d-flex align-center justify-center">{{ $t('orders') }}</span>
            </router-link>
            <router-link v-if="$isPermitted('viewUsers')" class="d-flex align-center justify-center"
                         :to="{name:'users'}">
                <span class="d-flex align-center justify-center">{{ $t('users') }}</span>
            </router-link>
            <router-link v-if="$isPermitted('viewRoles')" class="d-flex align-center justify-center"
                         :to="{name:'roles'}">
                <span class="d-flex align-center justify-center">{{ $t('roles') }}</span>
            </router-link>
            <router-link v-if="$isPermitted('viewOrganizations')" class="d-flex align-center justify-center"
                         :to="{name:'organizations'}">
                <span class="d-flex align-center justify-center">{{ $t('organizations') }}</span>
            </router-link>
        </v-toolbar-items>

        <v-spacer></v-spacer>

        <v-menu offset-y>
            <template v-slot:activator="{ on }">
                <v-list class="nav-person-menu">
                    <v-list-item>
                        <v-list-item-avatar tile width="66px" height="60px">
                            <!-- <v-img src="" cover>t</v-img> -->
                            <div>{{ name.charAt(0).toUpperCase() }}</div>
                        </v-list-item-avatar>
                        <v-list-item-content class="hidden-sm-and-down">
                            <v-list-item-title class="name-box">{{name}}</v-list-item-title>
                            <v-list-item-subtitle class="data-box">{{organisation}}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action v-on="on">
                            <v-icon large color="#5b8ff5">mdi-chevron-down</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
            </template>

            <v-list class="menu-open">
                <v-list-item v-if="$isPermitted('viewProfile') && profilePermission()" link height="62" @click="toProfile">
                    <v-list-item-icon>
                        <v-icon large color="#5b8ff5">mdi-account-box-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('my_profile') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item link height="62" @click="toInfo">
                    <v-list-item-icon>
                        <v-icon large color="#5b8ff5">mdi-information-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('info') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <Logout/>
            </v-list>
        </v-menu>

        <div class="language-switcher">
            <TheLanguageSwitcher/>
        </div>

        <v-navigation-drawer
                class="mobile-menu"
                v-model="mobileMenu"
        >
            <v-list nav dense>
                <v-list-item-group v-model="mobileMenuList">
                    <v-list-item v-if="$isPermitted('viewDashboard') && !dashboardProPermission()">
                        <v-list-item-title>
                            <router-link class="d-flex align-center" :to="{name:'dashboard'}">{{ $t('dashboard') }}
                            </router-link>
                        </v-list-item-title>
                    </v-list-item>

                    <v-list-item v-if="$isPermitted('viewDashboard') && dashboardProPermission()">
                        <v-list-item-title>
                            <router-link class="d-flex align-center" :to="{name:'dashboardPro'}">{{ $t('dashboard') }} Pro
                            </router-link>
                        </v-list-item-title>
                    </v-list-item>

                    <v-list-item v-if="$isPermitted('viewCmrs')">
                        <v-list-item-title>
                            <router-link class="d-flex align-center" :to="{name:'orders'}">{{ $t('orders') }}
                            </router-link>
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="$isPermitted('viewUsers')">
                        <v-list-item-title>
                            <router-link class="d-flex align-center" :to="{name:'users'}">{{ $t('users') }}
                            </router-link>
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="$isPermitted('viewRoles')">
                        <v-list-item-title>
                            <router-link class="d-flex align-center" :to="{name:'roles'}">{{ $t('roles') }}
                            </router-link>
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="$isPermitted('viewOrganizations')">
                        <v-list-item-title>
                            <router-link class="d-flex align-center" :to="{name:'organizations'}">{{ $t('organizations')
                                }}
                            </router-link>
                        </v-list-item-title>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>
    </v-app-bar>
</template>

<script>
    import Logout from '@/components/Logout'
    import TheLanguageSwitcher from '@/components/TheLanguageSwitcher'

    export default {
        components: {
            Logout,
            TheLanguageSwitcher
        },
        data() {
            return {
                mobileMenu: false,
                mobileMenuList: null,
                name: '',
                organisation: '',
            }
        },
        watch: {
            mobileMenuList() {
                this.mobileMenu = false
            },
            rourePath() {
                this.getName();
                this.getOrganization();
            }
        },
        computed: {
            rourePath() {
                return this.$route.path
            },
            logo() {
                return this.$store.state.loginUser.logo ? `data:image/jpeg;base64,${this.$store.state.loginUser.logo}` : null;
            },
        },
        methods: {
            toProfile() {
                this.$router.push({name: 'profile'})
            },
            toInfo() {
                window.open('https://collectgo.eu/', '_blank')
            },
            getName() {
                this.name = localStorage.getItem('userName')
            },
            getOrganization() {
                this.organisation = localStorage.getItem('organization')
            },
            dashboardProPermission() {
                return localStorage.getItem('showNewDashboardSign') === 'true'

            },
            profilePermission() {
                return localStorage.getItem('userId') !== '0'
            }
        },
        created() {
            this.getName();
            this.getOrganization();
        },
    }
</script>
